import { Link } from "react-router-dom";
import { SIGNUP_URL, SIGNIN_URL } from "../lib/config";
// WebP export of the wordmark (17 KB vs the 81 KB source PNG), served from
// public/ at 2x display size. Explicit width/height prevent layout shift.
const logoWordmark = "/meriana-wordmark.webp";
import PricingPill from "./PricingPill";
import { trackEvent, trackSignupCta } from "../lib/analytics";

export default function Nav({
  pill = "pricing",
}: {
  /** Homepage passes "signup" so the floating pill drives conversion. */
  pill?: "pricing" | "signup";
} = {}) {
  return (
    <>
      <nav className="sticky top-0 z-50 bg-white/90 backdrop-blur-sm border-b border-gray-200">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 min-h-16 sm:h-16 py-3 sm:py-0 flex flex-wrap sm:flex-nowrap items-center justify-between gap-x-2 gap-y-2">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img
              src={logoWordmark}
              alt="Meriana"
              width={644}
              height={70}
              className="h-4 sm:h-5 w-auto object-contain"
            />
          </Link>

          {/* Right side CTAs */}
          <div className="flex items-center gap-2 sm:gap-4 flex-shrink-0">
            <Link
              to="/games/"
              onClick={() => trackEvent("games_discovery_clicked", { location: "navigation", target: "games_landing" })}
              data-testid="link-nav-games"
              className="text-xs sm:text-sm font-semibold text-brand-600 hover:text-brand-500 transition-colors whitespace-nowrap"
            >
              Games
            </Link>
            <a
              href={SIGNIN_URL}
              className="text-xs sm:text-sm text-gray-600 hover:text-gray-900 transition-colors whitespace-nowrap"
            >
              Sign in
            </a>
            <a
              href={SIGNUP_URL}
              onClick={() => { if (window.location.pathname === "/") trackSignupCta("navigation"); }}
              className="bg-brand-500 hover:bg-brand-600 text-white text-xs sm:text-sm font-semibold px-2.5 sm:px-5 py-2 rounded-lg transition-colors whitespace-nowrap"
            >
              Get started
            </a>
          </div>
        </div>
      </nav>
      <PricingPill variant={pill} />
    </>
  );
}
